document.addEventListener('DOMContentLoaded', function() {
    //Move Awards on PDP Mobile down the page.
    function moveAwards() {
      const awards = document.querySelector('.awards');
      const productDetails = document.querySelector('.product-details');
      const galleryWrapper = document.querySelector('.product-gallery-wrapper');

      if (!awards || !productDetails || !galleryWrapper) return;
      if (window.innerWidth < 720) {
        // Move below .product-details on mobile
        productDetails.insertAdjacentElement('afterend', awards);
      } else {
        // Move into the .product-gallery-wrapper on desktop
        galleryWrapper.appendChild(awards);
      }
    }

    // Only run on PDP
    if (document.body.classList.contains('template-product')) {
      moveAwards(); 
      window.addEventListener('resize', moveAwards);
    }

    //Cart Layout for Mobile
    function moveCartInfo() {
      const cartInfo = document.querySelector(".cart-footer-info");
      const cartSidebar = document.querySelector(".column.totals");
      const cartFooter = document.querySelector(".cart-item-footer");

      if (!cartInfo || !cartSidebar || !cartFooter ) return;
      if (window.innerWidth < 1024) {
        // Move below on mobile
        cartSidebar.insertAdjacentElement('afterend', cartInfo);
      } else {
        // Move on desktop
        cartFooter.prepend(cartInfo);
      }
      
    }
    if (document.body.classList.contains('template-cart')) {
         moveCartInfo(); 
         window.addEventListener('resize', moveCartInfo);
    }
 
  });
